import { format, parse, parseISO } from 'date-fns'

export type DayOfTheWeek =
  | 'Monday'
  | 'Tuesday'
  | 'Wednesday'
  | 'Thursday'
  | 'Friday'
  | 'Saturday'
  | 'Sunday'

export const DAYS_OF_THE_WEEK: DayOfTheWeek[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export const toIsoDate = (source: string) => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(source)) {
    return undefined
  }
  return parseISO(source)
}

export const combineDateTime = (date: Date, time: Date) => {
  return parse(
    `${format(date, 'yyyy-MM-dd')} ${format(time, 'HH:mm:ss')}`,
    'yyyy-MM-dd HH:mm:ss',
    new Date()
  )
}
